<div class="flex flex-col confirm-create-instance-dialog h-100-percent">
  <app-sidenav-header [title]="title" [subtitle]="subtitle"></app-sidenav-header>

  <div class="flex flex-col basis-full overflow-y-auto">
    <div class="row name">
      <div class="label overline-font">{{ 'INSTANCE_SUMMARY.INSTANCE_NAME' | transloco | uppercase }}</div>
      <div class="value">{{ deployment.name }}</div>
    </div>

    <div class="row region">
      <div class="label overline-font">{{ 'INSTANCE_SUMMARY.CREATE_DEVELOPMENT_INSTANCE.REGION' | transloco | uppercase }}</div>
      <div class="value">{{ deployment.region }}</div>
    </div>

    <div class="row datazone">
      <div class="label overline-font">{{ 'INSTANCE_SUMMARY.CREATE_DEVELOPMENT_INSTANCE.DATA_ZONE' | transloco | uppercase }}</div>
      <div class="value">{{ deployment | resolveDeploymentSubscription }}</div>
    </div>

    <div class="row preferred-maintenance-day">
      <div class="label overline-font">{{ 'SERVICE.PREFERED_MAINTENANCE_DAY' | transloco | uppercase }}</div>
      <div class="value">{{ dayOfTheWeek }}</div>
    </div>

    <div class="row preferred-maintenance-time">
      <div class="label overline-font">{{ 'SERVICE.PREFERED_MAINTENANCE_TIME' | transloco | uppercase }}</div>
      <div class="value">{{ maintenanceWindow.startingHour }} - {{ maintenanceWindow.endingHour }} </div>
    </div>

    <div class="row request-description">
      <div class="label overline-font">{{ 'INSTANCE_SUMMARY.CREATE_DEVELOPMENT_INSTANCE.REQUEST_DESCRIPTION' | transloco | uppercase }}</div>
      <div class="value">{{ requestDescription }}</div>
    </div>
  </div>

  <mat-divider class="mb-32"></mat-divider>

  <div class="flex flex-row gap-x-4" dir="rtl">
    <button class="accent" type="button" (click)="confirmDeploy()">{{'BUTTONS.DEPLOY' | transloco}}</button>
    <button class="white" type="button" (click)="sidenavService.closeRightSidenav()">{{'BUTTONS.CANCEL' | transloco}}</button>
  </div>
</div>
